export default function cleanLocationTags(tags) {
	let ret = {
		postalCodeStartsWith: [],
		postalCode: [],
		postalRange: [],
		customText: [],
		polygon: [],
		address: [],
		countryCode: []
	};
	for (let tag of tags) {
		switch (tag.type) {
		case 'postalCodeStartsWith': ret.postalCodeStartsWith.push({ postalCode: tag.postalCode, op: tag.op }); break;
		case 'postalCode': ret.postalCode.push({ postalCode: tag.postalCode, op: tag.op }); break;
		case 'postalRange': ret.postalRange.push({ fromPostalCode: tag.fromPostalCode, toPostalCode: tag.toPostalCode, op: tag.op }); break;
		case 'countryCode': ret.countryCode.push({ countryCode: tag.countryCode, op: tag.op }); break;
		case 'customText': ret.customText.push({ searchText: tag.searchText, op: tag.op }); break;
		case 'polygon-filter': {
			let areaGeometry = tag.area ? tag.area.geometry : undefined;
			let geometry = tag.expanded ? tag.expanded : areaGeometry;
			ret.polygon.push({ geometry, op: tag.op });
		} break;
		case 'address': ret.address.push({
			name: tag.name,
			postalCode: tag.postalCode,
			countryCode: tag.countryCode,
			postalPlace: tag.postalPlace,
			street: tag.street,
			op: tag.op
		}); break;
		default: break;
		}
	}
	return ret;
}